module.exports = __webpack_public_path__ + "pc/img/swiper_logo_00.1e673af2.png";